// extracted by mini-css-extract-plugin
export default {"container":"bca-z","creativeContainer":"cca-z","copy":"dca-z","cta":"eca-z","disabled":"fca-z","flipped":"gca-z","productCard":"hca-z"};